module.exports = __webpack_public_path__ + "400e8e26577be006f7845cbcda9a0902.svg";